import { fetchHasSeen } from './fetch-has-seen/index.tsx';
import { setHasSeen } from './set-has-seen/index.tsx';

export const actions = {
	fetchHasSeen,
	setHasSeen,
} as const;
